// Maps a match probability (percent, 0-100) to a 1-10 Reality Score with a
// named band. The screenshot-friendly verdict that powers social sharing.

export interface RealityScore {
  score: number; // 1 (grounded) .. 10 (unicorn hunter)
  band: string;
  blurb: string;
}

const BANDS: { min: number; score: number; band: string; blurb: string }[] = [
  { min: 30, score: 1, band: "Realistic & Grounded", blurb: "Your standards match the market. Great dating prospects." },
  { min: 20, score: 2, band: "Grounded", blurb: "Very achievable preferences. Keep meeting people." },
  { min: 10, score: 3, band: "Balanced", blurb: "Reasonable standards with a healthy-sized pool." },
  { min: 5, score: 4, band: "Slightly Picky", blurb: "Selective but realistic with consistent effort." },
  { min: 3, score: 5, band: "Selective", blurb: "A narrower pool. Patience and social reach matter." },
  { min: 1, score: 6, band: "Very Selective", blurb: "High standards. Expanding your circles is essential." },
  { min: 0.5, score: 7, band: "Highly Selective", blurb: "You are filtering out over 99% of the population." },
  { min: 0.1, score: 8, band: "Dream Chaser", blurb: "A needle in a haystack. Consider which filters truly matter." },
  { min: 0.01, score: 9, band: "Highly Delusional", blurb: "Statistically, this person barely exists." },
  { min: -Infinity, score: 10, band: "Unicorn Hunter", blurb: "You are searching for a unicorn. The data says: recalibrate." },
];

export function getRealityScore(probabilityPercent: number): RealityScore {
  const match = BANDS.find((b) => probabilityPercent >= b.min) ?? BANDS[BANDS.length - 1];
  return { score: match.score, band: match.band, blurb: match.blurb };
}
